<script setup lang="ts">

const props = defineProps({
  error: {
    type: Object,
    required: true
  }
});
const config = useRuntimeConfig();

const is404 = () => {
  return [404, '404'].includes(props.error?.statusCode);
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-screen bg-black text-white">
    <img
      :src="config.public.bigLogoUrl"
      class="max-w-[400px]"
    >
    <div class="text-center">
      <div>
        <span class="text-white inline-block bg-gradient-to-b from-gray-500 to-background to-[75%] bg-clip-text font-mono text-[10rem] font-light text-transparent sm:text-[20rem]">
          {{ is404() ? '404' : '500' }}
        </span>
      </div>
      <div class="w-full items-center flex flex-col gap-4 mt-[-100px]">
        <h2 class="text-4xl mb-6 text-gradient-gray">
          {{ is404() ? 'Page not found' : 'Something went wrong' }}
        </h2>
      </div>
    </div>
  </div>
</template>
